import { useQuery } from "@tanstack/react-query";

import { offersQueryOptions, type OffersListParams } from "@/api/offerBank";

const OFFER_BLOCK_OFFERS_PARAMS: OffersListParams = {
  states: ["active"],
  pageSize: 100,
};

/**
 * Query options for the Offer block's offers list.
 * Used by both the route-level prefetch and the component-level hook
 * so they always share the same cache key.
 */
export const offerBlockQueryOptions = (siteId: string) => ({
  ...offersQueryOptions(siteId, OFFER_BLOCK_OFFERS_PARAMS),
  refetchOnWindowFocus: "always" as const,
});

/**
 * Shared offers query for Offer block traits (slug selector, static code).
 */
export function useOfferBlockOffers(siteId: string) {
  return useQuery(offerBlockQueryOptions(siteId));
}
